import 'tailwindcss/dist/base.min.css'
import 'typeface-roboto'

import {name,version} from './package.json'

console.log(`${name}: ${version}`)

export const onRouteUpdate = ({ location, prevLocation }) => {
  const _paq = window._paq;
  if (_paq) {
    location?.pathname && _paq.push(['setCustomUrl', location.pathname ]);
    _paq.push(['setDocumentTitle', document.title]);
    prevLocation?.pathname && _paq.push(['setReferrerUrl', prevLocation.pathname ]);
    _paq.push(['trackPageView']);
  }
}
